// extracted by mini-css-extract-plugin
module.exports = {"Home":"styles_Home__2GGG5"};